//  Externals
import { configureStore, StoreEnhancer } from '@reduxjs/toolkit';
import { persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { createInjectorsEnhancer } from 'redux-injectors';
import createSagaMiddleware from 'redux-saga';
//  Internals
import api from './middleware/api';
import createReducer from './reducers';
// Import all reducers
import entitiesReducer from './reducers/entities';
import masterDataReducer from './reducers/masterData';
import statusListReducer from './reducers/statusList';
import { reducer as userDataReducer } from './reducers/userData';

// Pre-inject essential reducers
const staticReducers = {
  entities: entitiesReducer,
  masterData: masterDataReducer,
  statusList: statusListReducer,
  userData: userDataReducer,
};

// Create initial reducer with pre-injected reducers
const initialReducer = createReducer(staticReducers);

//  Create the store with saga middleware
const sagaMiddleware = createSagaMiddleware({});
const { run: runSaga } = sagaMiddleware;

const enhancers = [
  createInjectorsEnhancer({
    createReducer,
    runSaga,
  }),
] as StoreEnhancer[];

export const store = configureStore({
  reducer: initialReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(sagaMiddleware, api),
  devTools: process.env.NODE_ENV !== 'production',
  enhancers,
});

export const persistor = persistStore(store);
